<!--suppress JSUnresolvedVariable -->
<template>
  <div class="mt-4 ml-1">
    <el-row>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/admin/dashboard' }"
          >管理中心
        </el-breadcrumb-item>
        <el-breadcrumb-item>基础配置</el-breadcrumb-item>
        <el-breadcrumb-item
          ><span class="text-primary">轮播图管理</span></el-breadcrumb-item
        >
      </el-breadcrumb>
    </el-row>
    <el-card class="my-3 mx-1">
      <div slot="header">
        <el-button
          @click="addBanner(0)"
          size="small"
          type="primary"
          plain
          :disabled="
            !adminPermissions.includes('/banner/admin/addOrUpdateBanner')
          "
        >
          新增轮播
        </el-button>
      </div>
      <el-table
        ref="multipleTable"
        :data="bannerList"
        tooltip-effect="dark"
        style="width: 100%;"
        height="417"
        stripe
        v-loading="loading"
        element-loading-text="拼命加载中"
      >
        <el-table-column
          prop="bannerId"
          label="轮播ID"
          sortable
          align="center"
          width="120"
        >
        </el-table-column>
        <el-table-column prop="gameName" label="游戏名称" align="center">
        </el-table-column>
        <el-table-column prop="imgUrl" label="缩略图" align="center">
          <template slot-scope="scope">
            <img
              style="width: 150px;height: 65px;"
              :src="scope.row.imgUrl"
              alt="缩略图"
            />
          </template>
        </el-table-column>
        <el-table-column label="状态" sortable align="center" width="138">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="激活"
              inactive-text="禁用"
              :disabled="
                !adminPermissions.includes('/banner/admin/addOrUpdateBanner')
              "
              @change="value => bannerStatusChange(value, scope.row)"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="bannerOrder" label="排序" align="center">
        </el-table-column>

        <el-table-column label="操作" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button
              @click="editBanner(scope.row.bannerId)"
              type="primary"
              plain
              size="small"
              :disabled="
                !adminPermissions.includes('/banner/admin/addOrUpdateBanner')
              "
              >编辑
            </el-button>
            <el-popconfirm
              placement="top"
              icon="el-icon-info"
              iconColor="red"
              title="确定要删除吗？"
              @onConfirm="deleteById(scope.row.bannerId)"
            >
              <el-button
                type="danger"
                slot="reference"
                plain
                class="ml-1"
                size="small"
                :disabled="
                  !adminPermissions.includes('/banner/admin/deleteBanner')
                "
              >
                移除
              </el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pt-3"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
  </div>
</template>

<!--suppress JSUnusedGlobalSymbols -->
<script>
export default {
  name: "IndexBanner",
  data() {
    return {
      bannerList: [],
      adminPermissions: this.$store.state.adminPermissions,
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0
    };
  },
  mounted() {
    this.getBannerList();
  },
  methods: {
    getBannerList() {
      this.loading = true;
      this.axios
        .get("/banner/admin/getBannerList", {
          params: {
            currentPage: this.currentPage,
            pageSize: this.pageSize
          }
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.bannerList = resp.data.data.records;
            this.total = resp.data.data.total;
            this.loading = false;
          }
        });
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getBannerList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getBannerList();
    },
    bannerStatusChange(status, banner) {
      this.axios
        .post("/banner/admin/addOrUpdateBanner", {
          bannerId: banner.bannerId,
          gameId: banner.gameId,
          status: status
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            if (status) {
              this.$notify({
                title: "成功",
                message: "轮播图已启用！",
                type: "success"
              });
            } else {
              this.$notify({
                title: "成功",
                message: "轮播图已禁用！",
                type: "success"
              });
            }
          }
        });
    },
    editBanner(bannerId) {
      this.$router
        .push({ name: "BannerForm", params: { bannerId: bannerId } })
        .catch();
    },
    addBanner(bannerId) {
      this.$router
        .push({ name: "BannerForm", params: { bannerId: bannerId } })
        .catch();
    },
    deleteById(bannerId) {
      this.axios
        .delete("/banner/admin/deleteBanner", {
          params: {
            bannerId: bannerId
          }
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.getBannerList();
            this.$notify({
              title: "成功",
              message: "删除成功",
              type: "success"
            });
          }
        });
    }
  }
};
</script>

<style scoped></style>
